export default __webpack_public_path__ + "static/media/Brimstone_artwork.a92e2f52.png";